import router from '@/router';

// 跳转app商品详情
export function goCommodityDetail(businessLine, commodityId) {
  window.JSBridge.invoke({
    bridgeName: 'goToProductDetailPage',
    data: {
      businessLine,
      commodityId,
    },
    callback: () => {},
  });
}

export function setTitle(title) {
  window.JSBridge.invoke({
    bridgeName: 'publicSetWebviewTitle',
    data: {
      title,
    },
    callback: () => {},
  });
}
export function closeWebview() {
  window.JSBridge.invoke({
    bridgeName: 'closeWeb',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    callback: () => {},
  });
}

export function goAppLogOut() {
  window.JSBridge.invoke({
    bridgeName: 'onLogout',
    callback: () => {},
  });
}

/**
 * APP注入的全局用户信息
 * @returns {*}
 */
export function getUserInfo() {
  return window?.bbUserInfo ?? {};
}

/**
 * APP注入的全局app信息
 * @returns {*}
 */
export function getAppInfo() {
  return window?.bbAppInfo ?? {};
}

/**
 * 返回app header所需参数
 */
export function getHeaderForApp(agent) {
  const {
    OSChannel,
    'req-agent': reqAgent,
    app_version: appVersion,
    AppBundleId,
    'device-sys-version': deviceSysVersion,
    'device-brand': deviceBrand,
    'device-name': deviceName,
    'device-identification': deviceIdentification,
    app_type: appType,
    // businessId,
    // organizationId,
    regionNames,
    // userName,
    token,
  } = getAppInfo();
  const {
    query,
  } = router.history.current;
  // console.log(userName, 'userName');
  // console.log(token, 'token', query.token);
  const headerParams = {
    OSChannel: OSChannel || query.OSChannel || 'web',
    'req-agent': reqAgent || agent || query.reqAgent || 'wapp-h5',
    app_version: appVersion || '',
    AppBundleId,
    token: token || query.token || '', // 小程序url传入
    // 'current-user-id': businessId || query.currentUserId || '',
    // 'current-user-name': encodeURIComponent(userName || query.currentUserName || ''),
    // 'current-department-id': organizationId || '',
    'sales-region-name': encodeURIComponent(regionNames || ''),
    'device-sys-version': deviceSysVersion || '',
    'device-brand': deviceBrand || '',
    'device-name': deviceName,
    'device-identification': deviceIdentification || '',
    app_type: appType || '',
  };
  return headerParams;
}

// 询价下单
export function orderOperate(data) {
  window.JSBridge.invoke({
    bridgeName: 'orderOperate',
    data: {
      orderOperate: data,
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    callback: () => {},
  });
}
